// Bilingual + dir="auto" because this renders when the React tree (and i18n)
// has crashed — t() is unsafe to call here.
export function ErrorFallback() {
  return (
    <div
      role="alert"
      data-slot="error-fallback"
      dir="auto"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
        padding: "1.5rem",
        textAlign: "center",
      }}
    >
      <div>
        <h1 style={{ fontSize: "1rem", fontWeight: 500, margin: 0 }}>
          Something went wrong
          <span style={{ display: "block" }}>حدث خطأ غير متوقع</span>
        </h1>
        <p style={{ fontSize: "0.875rem", opacity: 0.7, marginTop: "0.5rem" }}>
          The app hit an unexpected error. Reload to try again.
          <span style={{ display: "block" }}>
            واجه التطبيق خطأً غير متوقع. أعد التحميل للمحاولة مرة أخرى.
          </span>
        </p>
      </div>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          height: "2rem",
          padding: "0 1rem",
          borderRadius: "0.5rem",
          fontSize: "0.875rem",
          fontWeight: 500,
          cursor: "pointer",
        }}
      >
        Reload / إعادة التحميل
      </button>
    </div>
  );
}
